import React, { FormEvent, useEffect, useState } from "react";
import { useAuth } from "../../../firebase/AuthProvider";
import { useLocation, useNavigate } from "react-router-dom";
import Banner from "../../ui/Banner/Banner";
import "./Login.css";
import { getAuth, getMultiFactorResolver, MultiFactorResolver } from "firebase/auth";
import MfaVerifyPage from "./MfaVerifyPage";
import { loginWithBackend } from "../../../services/userServices/UserInfoService";
import { Button, Form } from "react-bootstrap";
import { Link } from 'react-router-dom';
import landingimg from "../../../assets/images/Login-main.png";
import landinglogo from "../../../assets/images/landinglogo.svg";
import eyecloseicon from "../../../assets/images/CloseEye.png";
import openeyeicon from "../../../assets/images/AiFillEye.png";
import { BsFillEyeFill } from "react-icons/bs";
import { BsFillEyeSlashFill } from "react-icons/bs";
import ErrorTooltip from "./ErrorTooltip";
import { toast } from "react-toastify";

const Login: React.FC = () => {
    const { login, logout } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();

    const [email, setEmail] = useState<string>("");
    const [password, setPassword] = useState<string>("");
    const [error, setError] = useState<string>("");
    const [showPassword, setShowPassword] = useState(false);
    const [mfaResolver, setMfaResolver] = useState<MultiFactorResolver | null>(null);
    const [validated, setValidated] = useState(false);
    const [isCheckboxChecked, setIsCheckBoxChecked] = useState<boolean>(true);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [fieldErrors, setFieldErrors] = useState<{
        email?: string;
        password?: string;
        terms?: string;
    }>({});
    const Eye = BsFillEyeFill as any;
    const CloseEye = BsFillEyeSlashFill as any;

    const from = (location.state as any)?.from?.pathname || "/home";

    const bannerError =
        error ||
        fieldErrors.email ||
        fieldErrors.password ||
        fieldErrors.terms ||
        "";


    useEffect(() => {
        logout();
    }, []);

    const handleLogin = async (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault(); // <<< THIS STOP PAGE RELOAD

        // Reset previous errors
        setFieldErrors({});

        const errors: {
            email?: string;
            password?: string;
            terms?: string;
        } = {};

        // Proper Email Validation
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!email) {
            errors.email = "Please enter your email";
        } else if (!emailRegex.test(email)) {
            errors.email = "Please enter a valid email address";
        }

        // Password not empty
        if (!password) {
            errors.password = "Please enter your password";
        }

        // ✅ Checkbox validation (NEW)
        if (!isCheckboxChecked) {
            errors.terms = "Please accept Terms of Service and Privacy Policy";
        }

        // If any errors, set state and stop login
        if (Object.keys(errors).length > 0) {
            setFieldErrors(errors);
            return;
        }

        const form = e.currentTarget;
        if (form.checkValidity() === false) {
            setValidated(true);
            return;
        }

        try {
            setIsLoading(true);
            const userCredential = await login(email, password);
            const idToken = await userCredential.user?.getIdToken();

            if (idToken) {
                const data = await loginWithBackend(idToken);
                if (data.data.requiresPasswordChange) {
                    navigate('/change-password');
                } else if (data?.code === "auth/multi-factor-auth-required") {
                    const resolver = getMultiFactorResolver(getAuth(), data);
                    setMfaResolver(resolver);
                } else if (data?.error) {
                    setError(data.error);
                } else {
                    navigate(from, { replace: true });
                }
            } else {
                setError("Could not retrieve ID token after login.");
                toast.error("Could not retrieve ID token after login.");
            }
        } catch (err: any) {
            if (err.code === "auth/multi-factor-auth-required") {
                const resolver = getMultiFactorResolver(getAuth(), err);
                setMfaResolver(resolver);
            } else {
                const fieldError = mapAuthErrorToField(err);

                if (fieldError) {
                    setFieldErrors(fieldError);
                } else {
                    const msg = getFirebaseLoginErrorMessage(err);
                    setError(msg);
                    toast.error(msg);
                }

                console.error(err);
            }
        }
        finally {
            setIsLoading(false);
        }
    };

    const getFirebaseLoginErrorMessage = (err: any): string => {
        const code = err?.code;

        switch (code) {
            case "auth/invalid-email":
            case "auth/user-not-found":
            case "auth/wrong-password":
            case "auth/invalid-credential":
                return "Invalid email or password";

            case "auth/user-disabled":
                return "This account is disabled. Contact support.";

            case "auth/too-many-requests":
                return "Too many failed attempts. Try again later.";

            default:
                return "Failed to login. Please try again.";
        }
    };

    const mapAuthErrorToField = (err: any) => {
        const code = err?.code;

        switch (code) {
            case "auth/invalid-email":
            case "auth/user-not-found":
                return {
                    email: "Invalid email address",
                };

            case "auth/wrong-password":
            case "auth/invalid-credential":
                return {
                    password: "Incorrect password",
                };

            case "auth/user-disabled":
                return {
                    email: "This account is disabled",
                };

            default:
                return null;
        }
    };



    const dismissBanner = () => setError("");
    const togglePassword = () => setShowPassword((prev) => !prev);

    return (
        <>
            <div className="!h-[100vh] "
                style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
            >

                {/* LEFT SECTION */}
                <div className="flex flex-col justify-center px-8 md:px-20 lg:px-28 py-10 w-full"
                    style={{ alignItems: "center", justifyContent: "center" }}
                >

                    {/* Logo */}
                    <div className="mb-10  flex justify-start w-full max-w-lg">
                        <img src={landinglogo} alt="landinglogo" className="h-10 w-auto" />
                    </div>

                    {/* <div className="w-full max-w-md">
                        {bannerError && (
                            <div className="mby_30">
                                <Banner
                                    message={bannerError}
                                    dismissBanner={() => {
                                        dismissBanner();
                                        setFieldErrors({});
                                    }}
                                    status="error"
                                />
                            </div>
                        )}
                    </div> */}

                    {/* Card */}
                    <div className="w-full max-w-lg">
                        {mfaResolver ? (
                            <MfaVerifyPage
                                resolver={mfaResolver}
                                onVerificationComplete={() => navigate(from, { replace: true })}
                                onCancel={() => setMfaResolver(null)}
                            />
                        ) : (
                            <div className="bg-white">
                                <div className="mb-4 xl:mb-8">
                                    {/* <h1 className="text-3xl font-semibold text-gray-900">Welcome Back!</h1> */}
                                    <p className="text-[#777777] mt-1">Enter your email and password.</p>
                                </div>

                                {/* FORM STARTS */}
                                <form onSubmit={handleLogin} noValidate>
                                    <div className="space-y-2 xl:space-y-6">

                                        {/* EMAIL */}
                                        {/* <div className="relative">
                                            {fieldErrors.email && (
                                                <ErrorTooltip message={fieldErrors.email} />
                                            )}

                                            <Form.Group controlId="email-input" className="flex flex-col gap-2">
                                                <Form.Label className="w-full flex justify-start text-base leading-[20px] tracking-[-0.15px] font-medium text-[#718096] font-inter">
                                                    E-mail
                                                </Form.Label>

                                                <Form.Control
                                                    type="email"
                                                    placeholder="example@gmail.com"
                                                    value={email}
                                                    onChange={(e) => {
                                                        setEmail(e.target.value);
                                                        setFieldErrors((prev) => ({ ...prev, email: undefined }));
                                                    }}

                                                    required
                                                    autoComplete="username"
                                                    className={`h-[48px] w-full !bg-white rounded-[8px] px-[16px] text-sm leading-[20px] tracking-[-0.15px] font-normal font-inter text-[#4A5568] placeholder-[#4A5568] focus:outline-none focus:ring-0`}
                                                    style={fieldErrors.email ? { border: "1px solid #d34a4f" } : { border: "1px solid #ccc" }}

                                                />
                                            </Form.Group>
                                        </div> */}

                                        <div className="relative">
                                            {fieldErrors.email && (
                                                <ErrorTooltip message={fieldErrors.email} />
                                            )}

                                            <div className="flex flex-col gap-3">
                                                <label className="w-full flex justify-start text-base leading-[20px] tracking-[-0.15px] font-medium text-[#718096] font-inter">
                                                    E-mail
                                                </label>

                                                <input
                                                    type="email"
                                                    placeholder="example@gmail.com"
                                                    value={email}
                                                    onChange={(e) => {
                                                        setEmail(e.target.value);
                                                        setFieldErrors((prev) => ({ ...prev, email: undefined }));
                                                    }}
                                                    required
                                                    autoComplete="username"
                                                    className={`h-[48px] w-full !bg-white rounded-[8px] px-[16px] text-sm leading-[20px] tracking-[-0.15px] font-normal font-inter text-[#4A5568] placeholder-[#4A5568] focus:outline-none focus:ring-0`}
                                                    style={fieldErrors.email ? { border: "1px solid #d34a4f" } : { border: "1px solid #ccc" }}
                                                />
                                            </div>
                                        </div>


                                        {/* PASSWORD */}
                                        {/* <div className="relative">
                                            {fieldErrors.password && (
                                                <ErrorTooltip message={fieldErrors.password} />
                                            )}

                                            <Form.Group controlId="password-input" className="flex flex-col gap-2">
                                                <Form.Label className="w-full flex justify-start text-base leading-[20px] tracking-[-0.15px] font-medium text-[#718096] font-inter">
                                                    Password
                                                </Form.Label>

                                                <div className="relative w-full">
                                                    <Form.Control
                                                        type={showPassword ? "text" : "password"}
                                                        placeholder="Enter your password"
                                                        value={password}
                                                        onChange={(e) => {
                                                            setPassword(e.target.value);
                                                            setFieldErrors((prev) => ({ ...prev, password: undefined }));
                                                        }}

                                                        required
                                                        autoComplete="current-password"
                                                        className={`h-[48px] w-full !bg-white rounded-[8px] px-[16px] pr-[52px] text-sm leading-[20px] tracking-[-0.15px] font-normal font-inter text-[#4A5568] placeholder-[#4A5568] focus:outline-none focus:ring-0`}
                                                        style={fieldErrors.password ? { border: "1px solid #d34a4f" } : { border: "1px solid #ccc" }}
                                                    />

                                                    <div
                                                        onClick={togglePassword}
                                                        className="absolute right-3 top-1/2 -translate-y-1/2 flex items-center border-l border-[#CFD9E0] pl-3 cursor-pointer"
                                                    >
                                                        {showPassword ? (
                                                            <Eye className="text-[#718096] text-xl" />
                                                        ) : (
                                                            <CloseEye className="text-[#718096] text-xl" />
                                                        )}
                                                    </div>
                                                </div>
                                            </Form.Group>
                                        </div> */}

                                        <div className="relative">
                                            {fieldErrors.password && (
                                                <ErrorTooltip message={fieldErrors.password} />
                                            )}

                                            <div className="flex flex-col gap-3">
                                                <label className="w-full flex justify-start text-base leading-[20px] tracking-[-0.15px] font-medium text-[#718096] font-inter">
                                                    Password
                                                </label>
                                                <div className="relative w-full">
                                                    <input
                                                        type={showPassword ? "text" : "password"}
                                                        placeholder="Enter your password"
                                                        value={password}
                                                        onChange={(e) => {
                                                            setPassword(e.target.value);
                                                            setFieldErrors((prev) => ({ ...prev, password: undefined }));
                                                        }}

                                                        required
                                                        autoComplete="current-password"
                                                        className={`h-[48px] w-full !bg-white rounded-[8px] px-[16px] pr-[52px] text-sm leading-[20px] tracking-[-0.15px] font-normal font-inter text-[#4A5568] placeholder-[#4A5568] focus:outline-none focus:ring-0`}
                                                        style={fieldErrors.password ? { border: "1px solid #d34a4f" } : { border: "1px solid #ccc" }}
                                                    />
                                                    <div
                                                        onClick={togglePassword}
                                                        className="absolute right-3 top-1/2 -translate-y-1/2 flex items-center border-l border-[#CFD9E0] pl-3 cursor-pointer"
                                                    >
                                                        {showPassword ? (
                                                            <Eye className="text-[#718096] text-xl" />
                                                        ) : (
                                                            <CloseEye className="text-[#718096] text-xl" />
                                                        )}
                                                    </div>
                                                </div>

                                            </div>
                                        </div>

                                        {/* FORGOT PASSWORD */}
                                        <div className="flex justify-end">
                                            <p
                                                onClick={() => navigate("/forgot-password")}
                                                className="text-[#7E57C2] underline text-sm font-medium cursor-pointer"
                                            >
                                                Forgot Password?
                                            </p>
                                        </div>

                                        {/* TERMS CHECKBOX */}
                                        <Form.Group controlId="terms-checkbox">
                                            <div className="flex !items-start gap-3 text-sm">
                                                <Form.Check.Input
                                                    checked={isCheckboxChecked}
                                                    type="checkbox"
                                                    required
                                                    style={fieldErrors.terms ? { border: "1px solid #d34a4f" } : { border: "1px solid #ccc" }}
                                                    onChange={(e) => setIsCheckBoxChecked(e.target.checked)}
                                                    className="mt-1"

                                                />
                                                <Form.Label className="font-poppins text-base font-normal leading-[131%] tracking-normal text-[#777777]">
                                                    By signing in or creating an account, you agree to our{" "}
                                                    <Link
                                                        to="/termsservices"
                                                        className="font-poppins text-base font-semibold leading-[131%] tracking-normal text-[#7E57C2] underline"
                                                    >
                                                        Terms of Service
                                                    </Link>{" "}
                                                    and{" "}
                                                    <Link
                                                        to="/privacypolicy"
                                                        className="font-poppins text-base font-semibold leading-[131%] tracking-normal text-[#7E57C2] underline"
                                                    >
                                                        Privacy Policy
                                                    </Link>.
                                                </Form.Label>

                                            </div>
                                        </Form.Group>

                                        {/* BUTTON */}
                                        <div className="pt-3">

                                            <button
                                                type="submit"
                                                disabled={isLoading}
                                                style={{ color: isLoading ? "black" : "" }}
                                                className="block w-full bg-[#7E57C2] text-white text-center hover:bg-[#6b46ac] !rounded-[10px] !py-[14px] !px-[22px] text-base no-underline cursor-pointer !text-[16px] !font-medium"
                                            >
                                                {isLoading ? "Signing in…" : "Sign in"}
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        )}
                    </div>
                </div>

                {/* RIGHT SIDE IMAGE */}
                <img src={landingimg} alt="landingimg" className="min-w-fit h-full hidden lg:block" />
                {/* <div className="hidden lg:flex !h-[100vh] w-fit justify-end">
                </div> */}
            </div>
        </>
    );
};

export default Login;